var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$vuetify.breakpoint.xs)?_c('div',[(_vm.timeZoneId)?_c('div',[_c('div',{staticClass:"headline font-weight-regular text-xs-right"},[_vm._v(_vm._s(_vm.currentTime))]),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.timeZoneId))])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }